export default {"src":"/_next/static/media/Rec_CanAnalytics.123dfeda.svg","height":39,"width":40,"blurWidth":0,"blurHeight":0};